import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\HASEE\\Documents\\ChatGPT\\生产项目\\cf-migrations\\nextwork\\build\\openclawmarketplace-xyz\\src\\components\\blocks\\pricing\\index.tsx");
